import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgArrowUpRight = (props, ref) => (_jsx("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: _jsx("path", { d: "M4.08325 9.91671L9.91659 4.08337M9.91659 4.08337H4.08325M9.91659 4.08337V9.91671", stroke: "currentColor", strokeWidth: 1.16667, strokeLinecap: "round", strokeLinejoin: "round" }) }));
const ForwardRef = forwardRef(SvgArrowUpRight);
export default ForwardRef;
